import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Card, Tabs, Spin, Dropdown, Menu } from "antd";
import GainIcon from "../../components/gainicon";
import Chart from "./chart";
import DataTable from "./datatable";

import Filter from "./filter";

import { getEmission } from "../../services/api";
import Description from "./description";
import Graph from "./graph";
import ChartDescription from "./components/Chartdescription";

import DATASET from "../../tools";

import _ from "lodash";

import ModalComponent from "./ModalComponent";

const { TabPane } = Tabs;

const { TECHNOLOGIES, YEARS, COLORS } = DATASET;

const EmissionContext = React.createContext();

export default function Emission(props) {
  const filter = {
    scenarios: [],
    sectors: [
      "TRA_RD_M4",
      "TRA_RD_LD4C",
      "TRA_RD_LD4T",
      "TRA_RD_HDT",
      "TRA_RD_HDB",
    ],
    rangestart: 2010,
    rangeend: 2050,
    activities: ["MD", "GSL", "LPG", "GAS"],
    technologies: [
      "HDEUI",
      "HDEUII",
      "HDEUIII",
      "HDEUIV",
      "HDEUV",
      "HDEUVI",
      "HDEUVII",
      "HDSEI",
      "HDSEII",
      "HDSEIII",
      "LFEUI",
      "LFEUII",
      "LFEUIII",
      "LFEUIV",
      "LFEUV",
      "LFEUVI",
      "MDEUI",
      "MDEUII",
      "MDEUIII",
      "MDEUIV",
      "MDEUV",
      "MDEUVI",
      "MDEUVII",
      "MDEUVIp",
      "MOT4I",
      "MOT4II",
      "MOT4III",
      "NSC_TRA",
    ],
    sheet: "Result_PM2.5",
  };

  const [filterData, setFilterData] = useState(filter);

  const [Tabkey, setTabkey] = useState(1);
  const [data, setData] = useState([]);
  const [ChartLoading, setChartLoading] = useState(false);
  const [ChartData, setChartData] = useState([]);

  const [ChartType, setChartType] = useState("column");
  const [GraphType, setGraphType] = useState("area");

  useEffect(() => {
    EmissionData();
  }, [filterData]);

  const EmissionData = useCallback(async () => {
    const scenarios = filterData.scenarios.map((item) => item.name);
    setChartLoading(true);
    const res = await getEmission(filterData);
    if (res.status === 200) {
      if (res.data.length > 0) {
        setData(res.data);
        const chartData = mapData(scenarios, res.data);
        // setChartData(chartData);
        setChartLoading(false);
      }
    } else {
      setData([]);
      setChartData([]);
      setChartLoading(false);
    }
  }, [filterData]);

  const chartSelect = (
    <Dropdown
      overlay={
        <Menu className="bg-gain rounded-lg">
          <Menu.Item
            className="text-white hover:bg-blue-900"
            onClick={() => setChartType("column")}
          >
            <span>Stacked Column</span>
          </Menu.Item>
          <Menu.Item
            className="text-white hover:bg-blue-900"
            onClick={() => setChartType("line")}
          >
            <span>Stacked Line</span>
          </Menu.Item>
        </Menu>
      }
      placement="bottomCenter"
      arrow
      trigger={["click"]}
    >
      <div className="cursor-pointer select-none">
        <GainIcon name="chart-dropdown" />
      </div>
    </Dropdown>
  );

  const graphSelect = (
    <Dropdown
      overlay={
        <Menu className="bg-gain rounded-lg">
          <Menu.Item
            className="text-white hover:bg-blue-900"
            onClick={() => setGraphType("area")}
          >
            <span>Area graph</span>
          </Menu.Item>
          <Menu.Item
            className="text-white hover:bg-blue-900"
            onClick={() => setGraphType("line")}
          >
            <span>Line graph</span>
          </Menu.Item>
        </Menu>
      }
      placement="bottomCenter"
      arrow
      trigger={["click"]}
    >
      <div className="cursor-pointer select-none">
        <GainIcon name="chart-dropdown" />
      </div>
    </Dropdown>
  );

  const mapData = (scenarios, data) => {
    const datasets = TECHNOLOGIES.filter((tech) =>
      filterData.technologies.includes(tech)
    ).reduce((totol, technoValue) => {
      scenarios.forEach((nameValue) => {
        totol.push({
          label: technoValue,
          stack: nameValue,
        });
      });
      return totol;
    }, []);

    const result = datasets.reduce((previos, current) => {
      const items = data.filter(
        (item) =>
          item.name === current.stack && item.technology === current.label
      );
      YEARS.filter(
        (y) => y >= filterData.rangestart && y <= filterData.rangeend
      ).forEach((year) => {
        const yearSum = items.reduce((yearTotal, item) => {
          if (item.year === year) {
            yearTotal += item.value;
          }
          return yearTotal;
        }, 0);

        previos.push({ ...current, year, value: +yearSum.toFixed(2) });
      });

      return previos;
    }, []);

    setChartData(result);
  };

  return (
    <EmissionContext.Provider
      value={{
        defaults: filter,
        filterData,
        setFilterData,
        EmissionData,
        data: data,
      }}
    >
      <h1 className="text-3xl font-bold">Emissions Iventory</h1>
      <div
        className={`grid grid-cols-3 2xl:grid-cols-4 gap-6 ${
          !props.embed ? "pt-8" : ""
        }`}
      >
        <Card
          title={false}
          className="border-none rounded-lg col-span-2 2xl:col-span-3 px-6 py-3"
        >
          <Tabs
            defaultActiveKey="1"
            onChange={(key) => setTabkey(key)}
            tabBarExtraContent={
              (Tabkey == 1 && chartSelect) || (Tabkey == 4 && graphSelect)
            }
          >
            <TabPane tab="Charts" key="1">
              <Spin tip="Data Loading..." spinning={ChartLoading}>
                <div className="pt-12">
                  <Chart data={ChartData} type={ChartType} />
                  <div className="flex justify-center items-center py-3 space-x-3">
                    {filterData.scenarios.map((item) => (
                      <ChartDescription label={item.name} />
                    ))}
                  </div>
                </div>
              </Spin>
            </TabPane>
            <TabPane tab="Data table" key="2">
              <Spin tip="Data Loading..." spinning={ChartLoading}>
                <DataTable />
              </Spin>
            </TabPane>
            {/* <TabPane tab="Traffic" key="3">
              <span className="text-red-500">
                ยังไม่มีรายละเอียดการแสดงข้อมูล Traffic
              </span>
            </TabPane> */}
            <TabPane tab="Graph" key="4">
              <Spin tip="Data Loading..." spinning={ChartLoading}>
                <Graph type={GraphType} />
              </Spin>
            </TabPane>
            <TabPane tab="Description" key="5">
              <Spin tip="Data Loading..." spinning={ChartLoading}>
                <Description />
              </Spin>
            </TabPane>
          </Tabs>
        </Card>
        <Card className="border-none rounded-lg px-6 py-3 max-h-screen-85 2xl:max-h-screen-65 overflow-y-auto">
          <div className="flex justify-between items-baseline pb-3">
            <h1 className="font-bold text-base"></h1>
          </div>
          <Filter currentTab={Tabkey} />
        </Card>
      </div>
      <ModalComponent embed={props.embed} />
    </EmissionContext.Provider>
  );
}

export { EmissionContext };
